/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TransPb } from "../body/trans";
import { Vector2dPb } from "../eigen_lcm/Vector2d";
import { Vector3dPb } from "../eigen_lcm/Vector3d";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface KeyframeTrans {
  unitSpeedTimeAlongTraj: number;
  position: Vector3dPb | undefined;
  orientationPy: Vector2dPb | undefined;
  vehiclePose: TransPb | undefined;
  flightId: string;
  utimeAdded: number;
  poseGraphVertexUtime: number;
  gimbalRoll: number;
}

function createBaseKeyframeTrans(): KeyframeTrans {
  return {
    unitSpeedTimeAlongTraj: 0,
    position: undefined,
    orientationPy: undefined,
    vehiclePose: undefined,
    flightId: "",
    utimeAdded: 0,
    poseGraphVertexUtime: 0,
    gimbalRoll: 0,
  };
}

export const KeyframeTrans = {
  encode(message: KeyframeTrans, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.unitSpeedTimeAlongTraj !== 0) {
      writer.uint32(9).double(message.unitSpeedTimeAlongTraj);
    }
    if (message.position !== undefined) {
      Vector3dPb.encode(message.position, writer.uint32(18).fork()).ldelim();
    }
    if (message.orientationPy !== undefined) {
      Vector2dPb.encode(message.orientationPy, writer.uint32(26).fork()).ldelim();
    }
    if (message.vehiclePose !== undefined) {
      TransPb.encode(message.vehiclePose, writer.uint32(34).fork()).ldelim();
    }
    if (message.flightId !== "") {
      writer.uint32(42).string(message.flightId);
    }
    if (message.utimeAdded !== 0) {
      writer.uint32(48).sint64(message.utimeAdded);
    }
    if (message.poseGraphVertexUtime !== 0) {
      writer.uint32(56).sint64(message.poseGraphVertexUtime);
    }
    if (message.gimbalRoll !== 0) {
      writer.uint32(65).double(message.gimbalRoll);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KeyframeTrans {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyframeTrans();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.unitSpeedTimeAlongTraj = reader.double();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.orientationPy = Vector2dPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.vehiclePose = TransPb.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.utimeAdded = longToNumber(reader.sint64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.poseGraphVertexUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.gimbalRoll = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyframeTrans {
    return {
      unitSpeedTimeAlongTraj: isSet(object.unitSpeedTimeAlongTraj)
        ? globalThis.Number(object.unitSpeedTimeAlongTraj)
        : 0,
      position: isSet(object.position) ? Vector3dPb.fromJSON(object.position) : undefined,
      orientationPy: isSet(object.orientationPy) ? Vector2dPb.fromJSON(object.orientationPy) : undefined,
      vehiclePose: isSet(object.vehiclePose) ? TransPb.fromJSON(object.vehiclePose) : undefined,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      utimeAdded: isSet(object.utimeAdded) ? globalThis.Number(object.utimeAdded) : 0,
      poseGraphVertexUtime: isSet(object.poseGraphVertexUtime) ? globalThis.Number(object.poseGraphVertexUtime) : 0,
      gimbalRoll: isSet(object.gimbalRoll) ? globalThis.Number(object.gimbalRoll) : 0,
    };
  },

  toJSON(message: KeyframeTrans): unknown {
    const obj: any = {};
    if (message.unitSpeedTimeAlongTraj !== 0) {
      obj.unitSpeedTimeAlongTraj = message.unitSpeedTimeAlongTraj;
    }
    if (message.position !== undefined) {
      obj.position = Vector3dPb.toJSON(message.position);
    }
    if (message.orientationPy !== undefined) {
      obj.orientationPy = Vector2dPb.toJSON(message.orientationPy);
    }
    if (message.vehiclePose !== undefined) {
      obj.vehiclePose = TransPb.toJSON(message.vehiclePose);
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.utimeAdded !== 0) {
      obj.utimeAdded = Math.round(message.utimeAdded);
    }
    if (message.poseGraphVertexUtime !== 0) {
      obj.poseGraphVertexUtime = Math.round(message.poseGraphVertexUtime);
    }
    if (message.gimbalRoll !== 0) {
      obj.gimbalRoll = message.gimbalRoll;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<KeyframeTrans>, I>>(base?: I): KeyframeTrans {
    return KeyframeTrans.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<KeyframeTrans>, I>>(object: I): KeyframeTrans {
    const message = createBaseKeyframeTrans();
    message.unitSpeedTimeAlongTraj = object.unitSpeedTimeAlongTraj ?? 0;
    message.position = (object.position !== undefined && object.position !== null)
      ? Vector3dPb.fromPartial(object.position)
      : undefined;
    message.orientationPy = (object.orientationPy !== undefined && object.orientationPy !== null)
      ? Vector2dPb.fromPartial(object.orientationPy)
      : undefined;
    message.vehiclePose = (object.vehiclePose !== undefined && object.vehiclePose !== null)
      ? TransPb.fromPartial(object.vehiclePose)
      : undefined;
    message.flightId = object.flightId ?? "";
    message.utimeAdded = object.utimeAdded ?? 0;
    message.poseGraphVertexUtime = object.poseGraphVertexUtime ?? 0;
    message.gimbalRoll = object.gimbalRoll ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
